import DialerStateContainer from './dialer.container';

export default DialerStateContainer;
